var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPositionBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.83877 1.88909C10.5961 0.131728 13.4454 0.131728 15.2027 1.88909L20.1525 6.83884C21.9098 8.5962 21.9098 11.4454 20.1525 13.2028L12.0208 21.3345L0.707043 10.0208L8.83877 1.88909Z",
    fill: "#BD2333",
    stroke: "#BD2333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPositionBg);
export default __webpack_public_path__ + "static/media/iconPositionBg.56d6b435a837a8f4f388e4a2fad3670a.svg";
export { ForwardRef as ReactComponent };